import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { Logout } from "../../common/Funcation";
import { postApi, notifyError } from "../../service";
import moment from "moment";
import Loader from "../../components/Loader";
import SimpleSearchInput from "../../components/SimpleSearchInput";

function MatchProfitLoss() {
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 2)),
  );
  const [endDate, setEndDate] = useState(new Date());
  const [tab, setTab] = useState("all");
  const [isLoader, setLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMatch, setSelectedMatch] = useState<any>(null);

  const navigate = useNavigate();
  const [pageData, setPageData] = useState<any>({});
  useEffect(() => {
    const { from, to } = formatDatesForApi(startDate, endDate);
    getPageData("", from, to, "", "all", "1");
    return () => {};
  }, []);

  const getPageData = async (
    ID: string = "",
    FROM: string = "",
    TO: string = "",
    FILTER: string = "",
    TYPE: string = "all",
    PAGE: string = "1",
  ) => {
    setLoader(true);
    let data: any = {
      api: ADMIN_API.REPORT.NEW_MARKET_REPORT,
      value: {
        page: PAGE ? PAGE : "1",
        limit: "500",
        type: "all",
      },
    };
    if (ID !== "") {
      data.value.id = ID;
    }
    if (TO !== "") {
      data.value.to = TO;
    }
    if (FROM !== "") {
      data.value.from = FROM;
    }
    if (FILTER !== "") {
      data.value.filter = FILTER;
    }

    await postApi(data)
      .then(function (response) {
        console.log(response);
        setPageData(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const formatDatesForApi = (start: Date, end: Date) => {
    const fromDate = moment(start).format("YYYY-MM-DD");
    const toDate = moment(end).format("YYYY-MM-DD");
    const from = `${fromDate}T00:00:00.000Z`;
    const to = `${toDate}T23:59:59.000Z`;
    return { from, to };
  };

  const getFilterButtonClick = () => {
    // Add time to dates for validation
    const startDateTime = moment(startDate).set({
      hour: 0,
      minute: 0,
      second: 0,
    });
    const endDateTime = moment(endDate).set({
      hour: 23,
      minute: 59,
      second: 59,
    });

    // Validate date range
    const daysDiff = moment(endDate).diff(moment(startDate), "days");

    if (daysDiff > 31) {
      notifyError("Date range cannot exceed 31 days");
      return;
    }

    // Validate full datetime (date + time)
    if (startDateTime.isAfter(endDateTime)) {
      notifyError("Start date/time cannot be after end date/time");
      return;
    }

    if (startDateTime.isSame(endDateTime)) {
      notifyError("Start date/time cannot be the same as end date/time");
      return;
    }

    setSelectedMatch(null);
    const fromDate = moment(startDate).format("YYYY-MM-DD");
    const toDate = moment(endDate).format("YYYY-MM-DD");
    const from = `${fromDate}T00:00:00.000Z`;
    const to = `${toDate}T23:59:59.000Z`;
    getPageData("", from, to, "", "all");
  };

  const clearFilter = () => {
    setSelectedMatch(null);
    const newStartDate = new Date(new Date().setDate(new Date().getDate() - 2));
    const newEndDate = new Date();
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    const { from, to } = formatDatesForApi(newStartDate, newEndDate);
    getPageData("", from, to, "", "all");
  };

  const selectMatchtype = (type: string) => {
    if (selectedMatch) return;
    setSelectedMatch(null);
    setTab(type === tab ? "all" : type);
    setSearchQuery("");
  };

  const handleMatchClick = (item: any) => {
    setSelectedMatch(item);
  };

  const handleBack = () => {
    setSelectedMatch(null);
  };

  const money = (value: any) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "0.00";
    return amount.toFixed(2);
  };

  const pnlColor = (value: any) => {
    const amount = Number(value) || 0;
    return amount < 0 ? "#d32f2f" : "#2e8b22";
  };

  const wonLabel = (won: any) => {
    if (won === 0 || won === "0" || won === "" || won == null) return "0";
    return String(won);
  };

  const detailRows = selectedMatch?.betsHistory || [];

  const detailTotal = detailRows.reduce(
    (sum: any, bet: any) => {
      sum.pnl += Number(bet?.pnl) || 0;
      sum.comP += Number(bet?.comP) || 0;
      sum.comN += Number(bet?.comN) || 0;
      sum.finalPnl += Number(bet?.finalPnl) || 0;
      return sum;
    },
    { pnl: 0, comP: 0, comN: 0, finalPnl: 0 },
  );

  return (
    <>
      <style>{`
        .table01 tbody td {
          font-weight: 700 !important;
          font-size: 13px;
          text-transform: capitalize;
          color: #1E1E1E;
        }
        .table01 th, .table01 td {
          padding: 5px !important;
        }
        .table01 tbody tr:nth-child(odd) td {
          background-color: #E5E5E5;
        }
        .table01 tbody tr:nth-child(even) td {
          background-color: #fff;
        }
        .mpl-table {
          width: 100%;
          border-collapse: collapse;
          background: #fff;
          font-size: 12px;
          border: 1px solid #c9c3b2;
          margin-top: 10px;
        }
        .mpl-table th {
          background: #E4E4E4 !important;
          color: #243a48 !important;
          font-weight: 700 !important;
          text-align: left;
          border: 1px solid #c9c3b2 !important;
          padding: 5px;
        }
        .mpl-table td {
          border: 1px solid #c9c3b2;
          padding: 10px 5px;
          text-align: left;
          font-weight: 400;
          background: #F2F4F7;
          vertical-align: middle;
          text-transform: capitalize;
        }
        .mpl-table tr.mpl-total-row td {
          background: #E4E4E4 !important;
          font-weight: 700;
          border: 1px solid #c9c3b2;
          padding: 5px !important;
        }
        .mpl-table td.mpl-total-label {
          text-align: center;
          font-weight: 700;
        }
        .mpl-table td.mpl-title {
          text-align: left;
          color: #1e1e1e;
          font-weight: 400;
          text-transform: capitalize;
        }
        .mpl-show-bets {
          background: #ffb80c;
          color: #111;
          border: 1px solid #111;
          font-size: 11px;
          font-weight: 700;
          padding: 3px 12px;
          cursor: pointer;
          line-height: 1.4;
          border-radius: 2px;
        }
        .mpl-show-bets:hover {
          background: #ffc83d;
        }
        .mpl-empty {
          text-align: center !important;
          font-weight: 600 !important;
          padding: 16px 8px !important;
        }
        .cal-input, .my-account-section_header input {
          padding: 5px;
        }
      `}</style>
      <div className="container full-wrap">
        <div className="top_header">
          <div className="top_header_title">
            <h5>Match Profit Loss</h5>
          </div>
        </div>

        <section className="my-account-section">
          <div
            className="my-account-section_header"
            style={{
              padding: "5px",
              background: "#E0E6E6",
              borderBottom: "1px solid #7e97a7",
            }}
          >
            <ul className="input-list">
              <li>
                <label>Period</label>
              </li>
              <li>
                <input
                  id="betsstartDate"
                  className="cal-input"
                  value={`${moment(startDate).format("YYYY-MM-DD")}`}
                  type="date"
                  placeholder="YYYY-MM-DD"
                  onChange={(e: any) => {
                    const newDate = new Date(e?.target?.value);
                    setStartDate(newDate);
                  }}
                />
                to
                <input
                  id="betsendDate"
                  className="cal-input"
                  value={`${moment(endDate).format("YYYY-MM-DD")}`}
                  type="date"
                  placeholder="YYYY-MM-DD"
                  onChange={(e: any) => {
                    setEndDate(new Date(e?.target?.value));
                  }}
                />
              </li>
              <li>
                <a
                  className="btn-send"
                  style={{
                    backgroundColor: "#FFB80C",
                    color: "#000",
                    border: "1px solid #000",
                  }}
                  onClick={() => getFilterButtonClick()}
                >
                  Apply
                </a>
              </li>
              <li>
                <a
                  className="btn"
                  style={{
                    backgroundColor: "#FFB80C",
                    color: "#000",
                    border: "1px solid #ffb80c",
                  }}
                  onClick={() => clearFilter()}
                >
                  Clear
                </a>
              </li>
            </ul>
          </div>
          <div className="my-account-section-content">
            <div
              className="d_flex"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <ul className="input-list">
                <li>
                  <a
                    className="btn-send"
                    style={{
                      backgroundColor: "rgb(255, 184, 12)",
                      color: "rgb(0, 0, 0)",
                      border: "1px solid rgb(0, 0, 0)",
                      width: "60px",
                      height: "31px",
                      lineHeight: "28px",
                      cursor: "pointer",
                    }}
                    onClick={() => selectMatchtype("cricket")}
                  >
                    Cricket
                  </a>
                </li>
                <li>
                  <a
                    className="btn-send"
                    style={{
                      backgroundColor: "rgb(255, 184, 12)",
                      color: "rgb(0, 0, 0)",
                      border: "1px solid rgb(0, 0, 0)",
                      width: "60px",
                      height: "31px",
                      lineHeight: "28px",
                      cursor: "pointer",
                    }}
                    onClick={() => selectMatchtype("soccer")}
                  >
                    Soccer
                  </a>
                </li>
                <li>
                  <a
                    className="btn-send"
                    style={{
                      backgroundColor: "rgb(255, 184, 12)",
                      color: "rgb(0, 0, 0)",
                      border: "1px solid rgb(0, 0, 0)",
                      width: "60px",
                      height: "31px",
                      lineHeight: "28px",
                      cursor: "pointer",
                    }}
                    onClick={() => selectMatchtype("tennis")}
                  >
                    Tennis
                  </a>
                </li>
              </ul>
              <div style={{ marginBottom: "10px" }}>
                <SimpleSearchInput
                  searchSubmit={(value: string) => setSearchQuery(value)}
                  placeholder="Search..."
                />
              </div>
            </div>
          </div>

          {/* {selectedMatch && (
            <div
              style={{
                padding: "8px 10px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#f0f4f5",
                marginBottom: "10px",
              }}
            >
              <button
                type="button"
                onClick={handleBack}
                style={{
                  backgroundColor: "#FFB80C",
                  color: "#000",
                  border: "1px solid #000",
                  padding: "4px 12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                &larr; Back to Matches
              </button>
              <h6 style={{ margin: 0, fontWeight: "bold", fontSize: "14px" }}>
                {selectedMatch?.name}
              </h6>
            </div>
          )} */}

          <div className="my-account-section-content-table">
            {isLoader && <Loader />}

            {selectedMatch ? (
              /* TABLE 1: Detail Bets Table (When Match is Selected) */
              <table className="mpl-table">
                <thead>
                  <tr>
                    <th style={{ width: "36%" }}>Title</th>
                    <th style={{ width: "8%" }}>P&amp;L</th>
                    <th style={{ width: "8%" }}>Com+</th>
                    <th style={{ width: "8%" }}>Com-</th>
                    <th style={{ width: "12%" }}>Won By</th>
                    <th style={{ width: "10%" }}>Net P&amp;L</th>
                    <th style={{ width: "18%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="mpl-total-row">
                    <td className="mpl-total-label">Total</td>
                    <td style={{ color: pnlColor(detailTotal.pnl) }}>
                      {money(detailTotal.pnl)}
                    </td>
                    <td style={{ color: "#2e8b22" }}>
                      {money(detailTotal.comP)}
                    </td>
                    <td style={{ color: "#d32f2f" }}>
                      {money(detailTotal.comN)}
                    </td>
                    <td></td>
                    <td style={{ color: pnlColor(detailTotal.finalPnl) }}>
                      {money(detailTotal.finalPnl)}
                    </td>
                    <td></td>
                  </tr>
                  {!isLoader &&
                    detailRows &&
                    detailRows.map((bet: any, i: number) => (
                      <tr key={`${bet?.title || "market"}-${i}`}>
                        <td className="mpl-title">{bet?.title}</td>
                        <td style={{ color: pnlColor(bet?.pnl) }}>
                          {money(bet?.pnl)}
                        </td>
                        <td style={{ color: "#2e8b22" }}>{money(bet?.comP)}</td>
                        <td style={{ color: "#d32f2f" }}>{money(bet?.comN)}</td>
                        <td>{wonLabel(bet?.won)}</td>
                        <td style={{ color: pnlColor(bet?.finalPnl) }}>
                          {money(bet?.finalPnl)}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="mpl-show-bets"
                            style={{
                              backgroundColor: "#FFB80C",
                              color: "#000",
                              border: "1px solid #000",
                              borderRadius: "4px",
                            }}
                            onClick={() => {
                              const matchId =
                                bet?.matchId ||
                                selectedMatch?._id ||
                                selectedMatch?.id ||
                                selectedMatch?.matchId;
                              const selection =
                                bet?.selection || bet?.title || "";
                              if (!matchId || !selection) return;
                              navigate(
                                `/showBetsCR/admin/${matchId}?selection=${encodeURIComponent(selection)}`,
                                {
                                  state: { matchId, selection },
                                }
                              );
                            }}
                          >
                            Show Bets
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              /* TABLE 2: Normal Matches Table (When No Match is Selected) */
              <table
                id="resultTable"
                className="table01 margin-table old-res table-s"
              >
                <thead>
                  <tr>
                    <th style={{ width: "4%" }} className="align-L blk">
                      S.No.
                    </th>
                    <th style={{ width: "8%" }} className="align-L blk">
                      Sport Name
                    </th>
                    <th style={{ width: "30%" }} className="align-L blk">
                      Match Name
                    </th>
                    <th style={{ width: "14%" }} className="align-L blk">
                      Match Date
                    </th>
                    <th style={{ width: "5%" }} className="align-L blk">
                      Pnl+
                    </th>
                    <th style={{ width: "7%" }} className="align-L blk">
                      Pnl-
                    </th>
                    <th style={{ width: "7%" }} className="align-L blk">
                      Commission
                    </th>
                    <th style={{ width: "4%" }} className="align-L blk">
                      Final P&amp;L
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontWeight: "bold" }}>
                  <tr style={{ backgroundColor: "#243A48", color: "#fff" }}>
                    <td></td>
                    <td></td>
                    <td style={{ color: "#243A48" }}>Total</td>
                    <td></td>
                    <td
                      className={
                        (pageData?.total?.pnlPlush ?? 0) >= 0
                          ? "text-green"
                          : "text-danger"
                      }
                      style={{
                        color:
                          (pageData?.total?.pnlPlush ?? 0) >= 0
                            ? "#28a745"
                            : "#dc3545",
                      }}
                    >
                      {pageData?.total?.pnlPlush ?? 0}
                    </td>
                    <td
                      className={
                        (pageData?.total?.pnl ?? 0) >= 0
                          ? "text-green"
                          : "text-danger"
                      }
                      style={{
                        color:
                          (pageData?.total?.pnl ?? 0) >= 0
                            ? "#28a745"
                            : "#dc3545",
                      }}
                    >
                      {pageData?.total?.pnl ?? 0}
                    </td>
                    <td
                      className={
                        (pageData?.total?.commission ?? 0) >= 0
                          ? "text-green"
                          : "text-danger"
                      }
                      style={{
                        color:
                          (pageData?.total?.commission ?? 0) >= 0
                            ? "#28a745"
                            : "#dc3545",
                      }}
                    >
                      {pageData?.total?.commission === 0 ||
                      !pageData?.total?.commission
                        ? "0.00"
                        : pageData?.total?.commission}
                    </td>
                    <td
                      className={
                        (pageData?.total?.finalPnl ?? 0) >= 0
                          ? "text-green"
                          : "text-danger"
                      }
                      style={{
                        color:
                          (pageData?.total?.finalPnl ?? 0) >= 0
                            ? "#28a745"
                            : "#dc3545",
                      }}
                    >
                      {pageData?.total?.finalPnl === 0 ||
                      !pageData?.total?.finalPnl
                        ? "0.00"
                        : pageData?.total?.finalPnl}
                    </td>
                  </tr>
                  {!isLoader &&
                    pageData?.report?.results &&
                    pageData?.report?.results
                      .filter((item: any) => {
                        const matchesTab =
                          tab === "all" ||
                          item?.type?.toLowerCase() === tab.toLowerCase();
                        if (!matchesTab) return false;

                        const query = searchQuery.toLowerCase().trim();
                        if (!query) return true;
                        return (
                          item?.type?.toLowerCase().includes(query) ||
                          item?.name?.toLowerCase().includes(query) ||
                          item?.openDate?.toLowerCase().includes(query)
                        );
                      })
                      .sort(
                        (a: any, b: any) =>
                          moment(b?.openDate).valueOf() -
                          moment(a?.openDate).valueOf(),
                      )
                      .map((item: any, i: any) => {
                        return (
                          <tr key={`${item?.name || "match"}-${i}`}>
                            <td>{i + 1}</td>
                            <td>{item?.type}</td>
                            <td>
                              <a
                                href="javascript:void(0)"
                                onClick={() => handleMatchClick(item)}
                                style={{
                                  color: "#2789ce",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                {item?.name}
                              </a>
                            </td>
                            <td>
                              {moment(item?.openDate).format(
                                "YYYY-MM-DD HH:mm:ss",
                              )}
                            </td>
                            <td className={item?.pnl > 0 ? "text-green" : ""}>
                              {item?.pnl > 0 ? item?.pnl : 0}
                            </td>
                            <td style={{ color: "#1E1E1E" }}>
                              {item?.pnl < 0 ? item?.pnl : 0}
                            </td>
                            <td
                              style={{
                                color:
                                  item?.commission === 0
                                    ? item?.finalPnl < 0
                                      ? "#1E1E1E"
                                      : "#28a745"
                                    : item?.commission > 0
                                      ? "#28a745"
                                      : "#dc3545",
                              }}
                            >
                              {item?.commission === 0
                                ? "0.00"
                                : item?.commission}
                            </td>
                            <td
                              className={
                                item?.finalPnl < 0
                                  ? "text-danger"
                                  : "text-green"
                              }
                            >
                              {item?.finalPnl === 0 ? "0.00" : item?.finalPnl}
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default MatchProfitLoss;
